function doInitializationWithGlobal(SPORTNETXPAGE) {
    let initialized = false;

    function loadingFinished() {
        if (initialized)
            return;

        initialized = true;

        SPORTNETXPAGE['startup'] = function(callback) {
            callback();
        };

        let waiters = SPORTNETXPAGE['__waiters'];

        if (waiters && waiters.length) {
            for (let i = 0, n = waiters.length; i < n; i++) {
                try {
                    waiters[i]();
                } catch (e) {
                    console.log("Error during startup function", e);
                }
            }
        }
    }

    if (document.readyState === 'loading') {
        document.onreadystatechange = function() {
            if (document.readyState === "interactive" || document.readyState === "complete") {
                loadingFinished();
            }
        };
    } else {
        loadingFinished();
    }
}

export default doInitializationWithGlobal;